import { Outlet, useNavigate } from "@tanstack/react-router"
import { useEffect } from "react"
import AppSidebar from "../sidebar/AppSidebar"
import { LoadingScreen } from "@/ui/components"
import { SidebarProvider } from "@/ui/components/ui/sidebar"
import { useAuth, useRedirectAfterLogin } from "@/auth"
import { useLocale } from "@/base"
import { useSyncUserLocale } from "@/profile"
import { Notifications } from "@/notification"

export default function UserRoute() {
  const { isLoading, isAuthenticated } = useAuth()
  const { setRedirectUrl } = useRedirectAfterLogin()
  const navigate = useNavigate()
  // App routes are not locale-prefixed; bounce to login in the user's locale.
  const locale = useLocale()
  // The signed-in user's stored locale is authoritative across the app.
  useSyncUserLocale()

  useEffect(() => {
    if (isLoading) {
      return
    }
    if (!isAuthenticated) {
      setRedirectUrl()
      void navigate({ to: "/$locale/auth", params: { locale }, replace: true })
    }
  }, [isLoading, isAuthenticated, navigate, setRedirectUrl, locale])

  if (isLoading || !isAuthenticated) {
    return <LoadingScreen />
  }

  return (
    <SidebarProvider>
      <AppSidebar />
      <div className="flex h-dvh min-w-0 flex-1 flex-col">
        <Notifications />
        <Outlet />
      </div>
    </SidebarProvider>
  )
}
